// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Roboto-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Roboto-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Roboto-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Roboto-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Roboto-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/Roboto-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/Roboto-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
}
.addButton {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  background-color: #ffffff;
  padding: 0.5rem 1rem;
  margin: 0 !important;
}
.addButton button {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 3rem);
  background: linear-gradient(to right, #1d2239, #4657a2, #1d2239);
  color: #ffffff;
  border-radius: 2rem;
  border: none;
  text-transform: uppercase;
  font-size: 1.1rem;
  line-height: 1.3rem;
  padding: 1rem 0;
  margin: 1rem 1.5rem;
}
.addButton button:active:not(:disabled) {
  box-shadow: 0 0.125rem 0.5rem #363c56;
  transform: translateY(0.125rem);
  opacity: 0.75;
}
.addButton button:disabled {
  background: rgb(200, 200, 200);
}
.addButton button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  max-width: 240px;
  white-space: nowrap;
  box-sizing: border-box;
  height: 3rem;
  padding: 0 1.5rem;
  margin: 0 !important;
  background: #515592;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 600;
  text-transform: none;
  border: none;
  border-radius: 100px;
  box-shadow: 0 4px 15px rgba(81, 85, 146, 0.3);
  cursor: pointer;
  transition: all 0.25s ease;
}
.addButton button .arrow {
  flex-shrink: 0;
  transition: transform 0.25s ease;
}
.addButton button:hover:not(:disabled) {
  filter: brightness(1.06);
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(81, 85, 146, 0.4);
}
.addButton button:hover:not(:disabled) .arrow {
  transform: translateX(3px);
}
.addButton button:active:not(:disabled) {
  filter: brightness(0.95);
  transform: translateY(1px);
  box-shadow: 0 2px 8px rgba(81, 85, 146, 0.25);
}
.addButton button:active:not(:disabled) .arrow {
  transform: translateX(1px);
}
.addButton button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/Theme/variables/_fonts.scss","webpack://./src/components/NextButton/NextButton.scss","webpack://./src/assets/Theme/variables/_colorSchema.scss","webpack://./src/assets/Theme/mixins/_app-button.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACCF;ADEA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACAF;ADGA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACDF;ADIA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACFF;ADKA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACHF;ADMA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACJF;ADOA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACLF;ADQA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACNF;ADSA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACPF;ADUA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACRF;ADWA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACTF;ADYA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACVF;AAnEA;EACE,WAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,yBCTM;EDUN,oBAAA;EACA,oBAAA;AAqEF;AAnEE;EEZA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gEDDe;ECEf,cDPM;ECQN,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AFkFF;AEjFE;EACE,qCAAA;EACA,+BAAA;EACA,aAAA;AFmFJ;AEjFE;EACE,8BDdO;ADiGX;AAxFI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBA1BU;EA2BV,cC7BE;ED8BF,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,YAAA;EACA,oBAAA;EACA,6CAAA;EACA,eAAA;EACA,0BAAA;AA0FN;AAvFI;EACE,cAAA;EACA,gCAAA;AAyFN;AAtFI;EACE,wBAAA;EACA,2BAAA;EACA,6CAAA;AAwFN;AAtFM;EACE,0BAAA;AAwFR;AApFI;EACE,wBAAA;EACA,0BAAA;EACA,6CAAA;AAsFN;AApFM;EACE,0BAAA;AAsFR;AAlFI;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;AAoFN","sourcesContent":["@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Thin.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-ThinItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-LightItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-Italic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Medium.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-MediumItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BoldItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Black.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BlackItalic.ttf') format('truetype');\n}\n","@import '../../assets/Theme';\n\n$brand_primary: #515592;\n\n.addButton {\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  background-color: $white;\n  padding: 0.5rem 1rem;\n  margin: 0 !important;\n\n  button {\n    @include app-button;\n\n    & {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 0.5rem;\n      width: 100%;\n      max-width: 240px;\n      white-space: nowrap;\n      box-sizing: border-box;\n      height: 3rem;\n      padding: 0 1.5rem;\n      margin: 0 !important;\n      background: $brand_primary;\n      color: $white;\n      font-size: 1rem;\n      font-weight: 600;\n      text-transform: none;\n      border: none;\n      border-radius: 100px;\n      box-shadow: 0 4px 15px rgba(81, 85, 146, 0.3);\n      cursor: pointer;\n      transition: all 0.25s ease;\n    }\n\n    .arrow {\n      flex-shrink: 0;\n      transition: transform 0.25s ease;\n    }\n\n    &:hover:not(:disabled) {\n      filter: brightness(1.06);\n      transform: translateY(-1px);\n      box-shadow: 0 6px 20px rgba(81, 85, 146, 0.4);\n\n      .arrow {\n        transform: translateX(3px);\n      }\n    }\n\n    &:active:not(:disabled) {\n      filter: brightness(0.95);\n      transform: translateY(1px);\n      box-shadow: 0 2px 8px rgba(81, 85, 146, 0.25);\n\n      .arrow {\n        transform: translateX(1px);\n      }\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n      box-shadow: none;\n    }\n  }\n}","$white: #ffffff;\n$text_dark: #2c2c2e;\n$text_gray: rgb(178, 181, 188);\n$buttonBg: #363c56;\n$errorText: #f70d1a;\n$buttonLinearBg: linear-gradient(to right, #1d2239, #4657a2, #1d2239);\n$msgDisable: rgb(150, 150, 150);\n$disabled: rgb(200, 200, 200);\n$light_gray: rgb(241, 241, 241);\n$unselectedText: rgb(80, 80, 80);\n$locationBnt: rgb(255, 255, 0);\n$spinner_blue: #3498db;\n\n$bg_unselected: rgb(188, 188, 224);\n$bg_selected: #559f5b;\n$bg_pending: #ccb137;\n$bg_frame: rgba(0, 0, 0, 0.6);\n\n$shadow: #2c2c2e5e;\n$light_shadow: rgba(49, 49, 52, 0.2);\n$highlighter: #eeff6e;\n$appt_bg: rgb(249, 249, 249);\n$red_bg: #cb101a;\n\n$notification_success: #4fae00;\n$notification_warning: #e4dd00;\n$notification_error: #be1000;\n","@mixin app-button() {\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: calc(100% - 3rem);\n  background: $buttonLinearBg;\n  color: $white;\n  border-radius: 2rem;\n  border: none;\n  text-transform: uppercase;\n  font-size: 1.1rem;\n  line-height: 1.3rem;\n  padding: 1rem 0;\n  margin: 1rem 1.5rem;\n  &:active:not(:disabled) {\n    box-shadow: 0 0.125rem 0.5rem $buttonBg;\n    transform: translateY(0.125rem);\n    opacity: 0.75;\n  }\n  &:disabled {\n    background: $disabled;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
